import dayjs from '../dayjs';

const YEAR_PATTERN = /^\d{4}$/;
const QUARTER_PATTERN = /^Q[1-4]\s+\d{4}$/i;
const ABBREVIATED_MONTHS = [
    'Jan.',
    'Feb.',
    'Mar.',
    'Apr.',
    'May',
    'Jun.',
    'Jul.',
    'Aug.',
    'Sep.',
    'Oct.',
    'Nov.',
    'Dec.',
] as const;

export const formatFinancialPeriodLabel = (value: unknown): string => {
    const label = String(value ?? '').trim();

    if (!label || YEAR_PATTERN.test(label) || QUARTER_PATTERN.test(label)) {
        return label;
    }

    const date = dayjs(label);

    return date.isValid() ? `${ABBREVIATED_MONTHS[date.month()]} ${date.format('Do, YYYY')}` : label;
};
